const API = "http://212.109.195.115/api/";

export const API_CALL_ME = `${API}call-me/`;
export const API_POSITION = `${API}position/`;
export const API_POSITION_ON_CATEGORIES = `${API}position/?category=`;
export const API_CATEGORIES = `${API}categories/`;
export const API_SHOPPING_CARD = `${API}shopping-card/`;
export const API_CONTACTS = `${API}users/me/`;
